import { FiMoreVertical } from 'react-icons/fi';
import { Dropdown } from 'react-bootstrap';
import EmptyState from './EmptyState';

/**
 * Generic list table. Standard pattern: per-row command buttons + a three-dot
 * mass-action menu in the header.
 * columns: [{ key, header, render?(row), width? }]
 * rowActions?(row) -> nodes ; massActions?: [{ label, onClick }]
 */
export default function DataTable({ columns, rows, loading, rowKey = 'id', rowActions, massActions, emptyMessage }) {
  if (loading) return <div className="hrms-muted" style={{ padding: 16 }}>Loading…</div>;
  if (!rows?.length) return <EmptyState message={emptyMessage || 'No records found.'} />;

  return (
    <table className="hrms-table">
      <thead>
        <tr>
          {columns.map((c) => <th key={c.key} style={{ width: c.width }}>{c.header}</th>)}
          {(rowActions || massActions) && (
            <th style={{ width: 48, textAlign: 'right' }}>
              {massActions && (
                <Dropdown align="end">
                  <Dropdown.Toggle as="span" role="button" bsPrefix="hrms-dots"><FiMoreVertical /></Dropdown.Toggle>
                  <Dropdown.Menu>
                    {massActions.map((a, i) => <Dropdown.Item key={i} onClick={a.onClick}>{a.label}</Dropdown.Item>)}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row[rowKey]}>
            {columns.map((c) => <td key={c.key}>{c.render ? c.render(row) : row[c.key]}</td>)}
            {(rowActions || massActions) && (
              <td style={{ textAlign: 'right' }}>
                <div className="hrms-row-actions" style={{ justifyContent: 'flex-end' }}>
                  {rowActions?.(row)}
                </div>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
